import { Box, Button, FormControl, SideSheet } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { getSectionHeaderStyles } from '~/styles';

export const ToolCartItemStyled = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;

export const MyCartHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  height: 50px;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #fff;
  justify-content: space-between;
  position: relative;
`;

export const MyCartSideSheetStyled = styled(SideSheet)`
  width: calc(100vw - ${({ theme }) => theme.componentStyles.navBarWidth});
`;

export const CartHeaderStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  background-color: ${({ theme }) => theme.colors.orange[100]};
`;

export const CartHeaderContainerStyled = styled(Box)`
  flex: 1;
  height: calc(100vh - 50px);
  overflow-y: auto;
`;

export const ClearButtonStyled = styled(Button)`
  background-color: ${({ theme }) => theme.colors.orange[100]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }

  &:focus {
    box-shadow: none;
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }
`;

export const FinalizeSectionStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  border-left: 1px solid ${({ theme }) => theme.colors.grey[200]};
`;

export const FinalizeSectionHeaderStyled = styled.div`
  ${getSectionHeaderStyles}
`;

export const FinalizeSectionBodyStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '500' },
  py: { sm: '500' },
})`
  flex: 1;
`;

export const InputTimeStyled = styled.input.attrs({ type: 'Time' })`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings['000']} ${theme.spacings[500]};
    border-radius: ${theme.radii[200]};
    border-color: ${theme.colors.grey[300]};
  `}
`;

export const ItemCountStyled = styled.div`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[600]};
    padding-top: ${theme.spacings[300]};
    padding-right: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[300]};
    border-radius: ${theme.radii[700]};
    border: 1px solid ${theme.colors.blue[800]};
  `}
`;

export const FormControlStyled = styled(FormControl)`
  & > :first-child {
    width: 100%;
  }
`;

export const TimeSectionStyled = styled.div`
  margin-top: ${({ theme }) => theme.spacings[600]};
`;

export const RemoveCartItemStyled = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    padding-top: ${theme.spacings[200]};
    padding-bottom: ${theme.spacings[300]};
    padding-left: ${theme.spacings[300]};
  `}
`;
